import TransmedValidator, {
  TransmedValidatorInput,
  TransmedValidatorUpdateInput,
} from "../../../dtos/transmed/process/validator";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../..";
import TransmedValidatorApi from "../../../api/transmed/validator";

class TransmedValidatorServiceReader extends ServiceReader {
  public async current(): Promise<TransmedValidator[]> {
    return await new TransmedValidatorApi().get();
  }
}

class TransmedValidatorServiceCreator extends ServiceCreator {
  public async validator(public_id: string): Promise<TransmedValidator> {
    return await new TransmedValidatorApi().post(
      new TransmedValidatorInput(public_id)
    );
  }
}

class TransmedValidatorServiceUpdater extends ServiceUpdater {
  public async allowEdit(
    id: number,
    allowEdit: boolean
  ): Promise<TransmedValidator> {
    return await new TransmedValidatorApi().put(
      `${id}`,
      new TransmedValidatorUpdateInput(allowEdit)
    );
  }
}

class TransmedValidatorServiceDeleter extends ServiceDeleter {
  public async validator(id: number): Promise<void> {
    return await new TransmedValidatorApi().delete(`${id}`);
  }
}

export default class TransmedValidatorService extends Service {
  public get read(): TransmedValidatorServiceReader {
    return new TransmedValidatorServiceReader();
  }
  public get create(): TransmedValidatorServiceCreator {
    return new TransmedValidatorServiceCreator();
  }
  public get update(): TransmedValidatorServiceUpdater {
    return new TransmedValidatorServiceUpdater();
  }
  public get delete(): TransmedValidatorServiceDeleter {
    return new TransmedValidatorServiceDeleter();
  }
}
